module.exports = __webpack_public_path__ + "img/nuke.75df0684.svg";